import z from "zod";
import { baseEntitySchema } from "./base";

const optionalEmailSchema = z.preprocess((value) => {
  if (typeof value !== "string") {
    return value;
  }

  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return undefined;
  }

  return normalizedValue;
}, z.string().email().optional());

export enum VendorSource {
  CRM = "CRM",
  BROKER = "BROKER",
  FRIEND = "FRIEND",
  FAMILY = "FAMILY",
}

export const VendorDataSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string(),
  phone: z.string().min(1),
  secondaryPhone: z.string().optional(),
  secondaryEmail: optionalEmailSchema,
  companyName: z.string().optional(),
  source: z.nativeEnum(VendorSource),
});

export type VendorData = z.infer<typeof VendorDataSchema>;
export const vendorSchema = baseEntitySchema.extend(VendorDataSchema.shape);
export type Vendor = z.infer<typeof vendorSchema>;
